import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { CalAngularService } from "@cvx/cal-angular";
import { catchError, switchMap, throwError } from "rxjs";
import { environment } from "../../environments/environment";

export const TokenInterceptor: HttpInterceptorFn = (req, next) => {

    const calService = inject(CalAngularService);
    const router = inject(Router);

    return calService.getAADToken([environment.clientId + "/user_impersonation"], false).pipe(
        switchMap(token => {
            const authReq = req.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`
                }
            });
            return next(authReq).pipe(
                catchError((err: HttpErrorResponse) => {
                    if (err.status === HttpStatusCode.Unauthorized || err.status === HttpStatusCode.Forbidden) {
                        router.navigate(["/unauthorized"]);
                    }
                    return throwError(() => err);
                })
            );
        }));
}